import type { FC } from 'react';
import { memo, useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { betsCouponPreviewV2Reset, selectCouponPossibleOddsV2 } from '@mwl/core-lib';
import { Button } from '@/components/Button/Button';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
import { CouponBet } from '../CouponBet/CouponBet';
import { CouponDataRow } from '../CouponDataRow/CouponDataRow';
import type { CouponBetsListProps } from './CouponBetsList.types';
import styles from './CouponBetsList.module.scss';
const BaseCouponBetsList: FC<CouponBetsListProps> = ({
  bets
}) => {
  const {
    t
  } = useTranslation('sport');
  const dispatch = useTypedDispatch();
  const possibleOdds = useTypedSelector(selectCouponPossibleOddsV2) || 0;
  const handleClearCoupon = useCallback(() => {
    dispatch(betsCouponPreviewV2Reset());
  }, [dispatch]);
  return <div className={styles.root} data-sentry-component="BaseCouponBetsList" data-sentry-source-file="CouponBetsList.tsx">
      {(bets ?? []).map(bet => <CouponBet key={bet.line?.id} {...bet} withRefuse />)}
      <Button as="button" rounded size="sm" cut={false} color="grey" className={styles.clearCoupon} onClick={handleClearCoupon} uppercase fontWeight="bold" data-sentry-element="Button" data-sentry-source-file="CouponBetsList.tsx">
        <span>{t('coupon.clear_coupon', 'Clear Coupon')}</span>
      </Button>

      {possibleOdds != null && bets.length > 0 && <CouponDataRow className={styles.overall} title={t('coupon.final_coeff', 'Final coefficient:')} value={possibleOdds} />}
    </div>;
};
export const CouponBetsList = memo(BaseCouponBetsList);
CouponBetsList.displayName = 'CouponBetsList';